import { Base, Component } from '@/vue-property-decorator'
import DownlodAppByClickGame from './download-app-by-click-game'
import DownlodAppByDefault from './download-app-by-default'
import DownlodAppBySite from './download-app-by-site'
@Component<DownlodApp>({ name: 'DownlodApp' })
export default class DownlodApp extends Base {
  render() {
    return (
      <template>
        <DownlodAppByDefault />
        <DownlodAppByClickGame />
        <DownlodAppBySite />
      </template>
    )
  }
}
